import { gql } from 'graphql-tag';

export const UPDATE_USER = gql`
  mutation updateUser($userId: String!, $user: UserInput!) {
    updateUser(userId: $userId, user: $user) {
      user {
        dob
        email
        firstname
        gender
        lastname
        phoneNumber
        roles
        userId
        address
        city
        postalCode
        state
      }
    }
  }
`;
